import { OmniLightTheme, OmniTheme } from '@aiz-gl/omni-ui';
import { icons } from './icons';

export const DarkTheme: OmniTheme = {
  ...OmniLightTheme,
  name: 'Asset IQ Dark',
  icons,
  colors: {
    primary: '#17223A', // UPDATED
    secondary: '#2D4372', // UPDATED
    tertiary: '#39548E', // UPDATED
    quaternary: '#4464AA', // UPDATED
    warn: '#ED2121', // UPDATED
    success: '#4EAC42', // UPDATED
    disabled: '#C9C9C9', // UPDATED
    light: '#EBEBEB', // UPDATED
    dark: '#4d4d4d',
    'primary-container': '#082a40', // UPDATED
    'secondary-container': '#b3e7c2',
    'tertiary-container': '#ffe2b3',
    'warn-container': '#ffc2b3',
    'success-container': '#b3e7c2',
    'disabled-container': '#f2f2f2',
    'primary-surface': '#082a40', // UPDATED
    'secondary-surface': '#0a324c', // UPDATED
    'tertiary-surface': '#f2f2f2',
    'quaternary-surface': '#abcde5',
    'disabled-surface': '#fff',
    'inverse-surface': '#4d4d4d',
    background: '#fff',
    scrim: 'rgba(0,0,0,0.2)',
    ghost: 'transparent',
    transparent: 'transparent',

    'on-primary': '#F7F9FC',
    'on-secondary': '#F7F9FC',
    'on-tertiary': '#F7F9FC',
    'on-quaternary': '#F7F9FC',
    'on-warn': '#fff',
    'on-success': '#fff',
    'on-disabled': '#fff',
    'on-primary-container': '#377EF7', // UPDATED
    'on-secondary-container': '#4EAC42',
    'on-tertiary-container': '#ff7200',
    'on-warn-container': '#ED2121',
    'on-success-container': '#4EAC42',
    'on-disabled-container': '#f1f1f1',
    'on-primary-surface': '#f1f1f1',
    'on-secondary-surface': '#f1f1f1',
    'on-tertiary-surface': '#4d4d4d',
    'on-quaternary-surface': '#4d4d4d',
    'on-disabled-surface': '#4d4d4d',
    'on-inverse-surface': '#fff',
    'on-primary-surface-variant': 'rgba(255,255,255,0.9)',
    'on-secondary-surface-variant': '#0070B9',
    'on-tertiary-surface-variant': '#0070B9',
    'on-inverse-surface-variant': '#cce4f1',
    'on-background': '#4d4d4d',
    'on-background-variant': '#959595',
  },

  spacing: {
    none: 'none',
    xxs: '2px',
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '32px',
    xl: '64px',
  },

  thicknesses: {
    thin: 1,
    standard: 2,
    thick: 2,
  },

  radii: {
    none: 'none',
    xxs: '4px',
    xs: '8px',
    sm: '16px',
    md: '24px',
    lg: '32px',
    max: '999px',
  },

  borders: {
    primary: '1px solid #0070b9',
    secondary: '1px solid #00b034',
    tertiary: '1px solid #ff9f00',
    quaternary: '1px solid #4d4d4d',
    warn: '1px solid #ff3300',
    light: '1px solid #C9C9C9',
  },

  shadows: {
    raised: '0 3px 6px rgba(0,0,0,0.1), 0 3px 6px rgba(0,0,0,0.18)',
    menu: 'rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px;',
    dialog:
      'rgba(0, 0, 0, 0.2) 0px 3px 5px -1px, rgba(0, 0, 0, 0.14) 0px 6px 10px 0px, rgba(0, 0, 0, 0.12) 0px 1px 18px 0px',
  },

  typeFaces: {
    'display-large': {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '50px',
      lineHeight: '60px',
      letterSpacing: '-0.25px',
    },
    'display-medium': {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '40px',
      lineHeight: '52px',
      letterSpacing: '-0.25px',
    },
    'display-small': {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '36px',
      lineHeight: '42px',
    },
    'headline-large': {
      fontFamily: 'Helvetica Bold, sans-serif',
      fontSize: '24px',
      lineHeight: '32px',
      fontWeight: '600',
    },
    'headline-medium': {
      fontFamily: 'Helvetica Bold, sans-serif',
      fontSize: '20px',
      lineHeight: '28px',
      letterSpacing: '0.15px',
      fontWeight: '600',
    },
    'headline-small': {
      fontFamily: 'Helvetica Bold, sans-serif',
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: '0.3px',
      fontWeight: '600',
    },
    'title-large': {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '24px',
      lineHeight: '32px',
    },
    'title-medium': {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '20px',
      lineHeight: '28px',
      letterSpacing: '0.15px',
    },
    'title-small': {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: '0.1px',
    },
    'body-1-long': {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '16px',
      lineHeight: '22px',
    },
    'body-1-short': {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '16px',
      lineHeight: '24px',
    },
    'body-2-long': {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '14px',
      lineHeight: '18px',
    },
    'body-2-short': {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '14px',
      lineHeight: '20px',
    },
    'subtitle-1': {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.15px',
    },
    'subtitle-2': {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.1px',
    },
    label: {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '16px',
      lineHeight: '20px',
    },
    caption: {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '12px',
      lineHeight: '18px',
      letterSpacing: '0.4px',
    },
    overline: {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '10px',
      lineHeight: '18px',
      letterSpacing: '1.5px',
      textTransform: 'uppercase',
    },
    paragraph: {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '16px',
      lineHeight: '24px',
    },
    badge: {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '16px',
      lineHeight: '24px',
    },
    note: {
      fontFamily: 'Helvetica, sans-serif',
      fontSize: '14px',
      lineHeight: '22px',
      fontStyle: 'italic',
    },
  },
  components: {
    ...OmniLightTheme.components,
    dialog: {
      ...OmniLightTheme.components.dialog,
      options: {
        ...OmniLightTheme.components.dialog?.options,
        backdrop: {
          background: 'rgba(0, 0, 0, 0.4)',
          backdropFilter: 'blur(2px)',
        },
      },
    },
    button: {
      fixed: {
        position: 'relative',
        overflow: 'hidden',
        outline: '0',
        border: '0',
        cursor: 'pointer',
        fontFamily: 'Euphemia, sans-serif',
        transition: 'all 0.28s ease',
      },
      colors: {
        ghost: {
          backgroundColor: 'transparent',
          color: 'currentcolor',
        },
        primary: {
          backgroundColor: '#0070b9',
          color: '#fff',
        },
        secondary: {
          backgroundColor: '#2B53A2',
          color: '#fff',
        },
        tertiary: {
          backgroundColor: '#4EAC42',
          color: '#fff',
        },
        warn: {
          backgroundColor: '#ED2121',
          color: '#fff',
        },
        disabled: {
          backgroundColor: '#b3b3b3 !important',
          color: '#fff !important',
        },
      },
      sizes: {
        sm: {
          height: 22,
          borderRadius: 11,
          fontSize: 12,
          padding: '0 12px',
          fontFamily: 'Euphemia Bold, sans-serif',
          fontWeight: 600,
        },
        md: {
          height: 26,
          borderRadius: 13,
          fontSize: 16,
          padding: '0 16px',
        },
        lg: {
          height: 36,
          borderRadius: 18,
          fontSize: 18,
          padding: '0 18px',
        },
        xl: {
          height: 48,
          borderRadius: 24,
          fontSize: 24,
          padding: '0 22px',
        },
      },
    },
    iconButton: {
      colors: {
        ghost: {
          backgroundColor: 'transparent',
          color: 'currentcolor',
        },
        primary: {
          backgroundColor: '#0070b9',
          color: '#fff',
        },
        secondary: {
          backgroundColor: '#2B53A2',
          color: '#fff',
        },
        tertiary: {
          backgroundColor: '#4EAC42',
          color: '#fff',
        },
        warn: {
          backgroundColor: '#ED2121',
          color: '#fff',
        },
        disabled: {
          backgroundColor: 'transparent !important',
          color: 'rgba(0,0,0,0.25) !important',
        },
      },
      sizes: {
        sm: {
          height: 22,
          minHeight: 22,
          width: 22,
          minWidth: 22,
          fontSize: 18,
        },
        md: {
          height: 26,
          minHeight: 26,
          width: 26,
          minWidth: 26,
          fontSize: 22,
        },
        lg: {
          height: 36,
          minHeight: 36,
          width: 36,
          minWidth: 36,
          fontSize: 30,
        },
        xl: {
          height: 40,
          minHeight: 40,
          width: 40,
          minWidth: 40,
          fontSize: 34,
        },
      },
    },
    progressGauge: {
      fixed: {
        textFill: '#4d4d4d',
      },
      colors: {
        primary: {
          backgroundColor: '#b3d4ea',
          color: '#0070b9',
        },
        secondary: {
          backgroundColor: '#b3e7c2',
          color: '#00b034',
        },
        tertiary: {
          backgroundColor: '#ffe2b3',
          color: '#ff9f00',
        },
        warn: {
          backgroundColor: '#ffc2b3',
          color: '#ff3300',
        },
      },
      sizes: {
        sm: { height: '54px' },
        md: { height: '68px' },
        lg: { height: '82px' },
      },
    },
    card: {
      fixed: {
        borderStyle: 'solid',
        borderWidth: '1px',
        borderRadius: '25px',
        overflow: 'hidden',
      },
      colors: {
        primary: {
          borderColor: '#0070b9',
          backgroundColor: '#fff',
        },
        secondary: {
          borderColor: '#00b034',
          backgroundColor: '#fff',
        },
        tertiary: {
          borderColor: '#ff9f00',
          backgroundColor: '#fff',
        },
        warn: {
          borderColor: '#ff3300',
          backgroundColor: '#fff',
        },
      },
    },
    cardHeader: {
      fixed: { padding: '12px 24px' },
      colors: {
        primary: {
          backgroundColor: '#0070b9',
          color: '#fff',
        },
        secondary: {
          backgroundColor: '#00b034',
          color: '#fff',
        },
        tertiary: {
          backgroundColor: '#ff9f00',
          color: '#fff',
        },
        warn: {
          backgroundColor: '#ff3300',
          color: '#fff',
        },
      },
    },
    cardContent: {
      fixed: {
        padding: '12px 24px',
      },
    },
  },
};
